// libs
import { SWRResponse } from 'swr';
// App
import { SHOP_OPERATIONS_SHOPS_URL } from '../shop.constants';
import { useSWRAxiosGetRequest } from 'app-shared/lib/api/utils/swr-axios-request.hooks';
import { API_SHOP_OPERATIONS_BASE_URL } from 'app-shared/lib/api/utils/api.constants';
import { ORDER_STATUS } from 'app-shared/lib/api/shared/order.interfaces';

const SECOND = 1000;
const MINUTE = SECOND * 60;
const REFETCH_ORDERS_COUNT_INTERVAL = 2 * MINUTE;

const buildShopOrdersCountUrl = (shopId: number, startDate: Date, endDate: Date, statuses: ORDER_STATUS[]): string => {
  const statusesQueryStringPart = statuses.map((status) => `&status=${status}`).join('');
  const url = `${API_SHOP_OPERATIONS_BASE_URL}/${SHOP_OPERATIONS_SHOPS_URL}/${shopId}/orders/count?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}${statusesQueryStringPart}`;

  return url;
};

/**
 * Count the orders of a shop over a period having one of the given statuses
 */
export const useCountShopOrders = (
  shopId: number | undefined,
  startDate: Date,
  endDate: Date,
  statuses: ORDER_STATUS[]
): SWRResponse<number, Error> => {
  const urlOptional = (shopId && buildShopOrdersCountUrl(shopId, startDate, endDate, statuses)) || null;

  return useSWRAxiosGetRequest(urlOptional, {
    revalidateOnFocus: false,
    refreshInterval: REFETCH_ORDERS_COUNT_INTERVAL,
  });
};
